var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.429 1v9.429H7.285l4.717 8.165 4.713-8.165h-3.144V1H10.43zm11 17.285v3.144H2.57v-3.144H1V23h22v-4.715h-1.571z",
    transform: "translate(-915 -478) translate(915 478)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconSolid);
export default __webpack_public_path__ + "static/media/download-icon-solid.887eba3310a706b709c3380d5a554e50.svg";
export { ForwardRef as ReactComponent };